import { getCoinConfig } from '../api/coinConfig'

/**
 * 需在宿主组件选项上声明 coinCostKey：'shortNovel' | 'coreIdea' | 'outline' | 'cover'
 *（与 MyNovels / ProfileSection 一致：mounted + watch active）
 * 父级传入 active，进入对应创作区时拉取 /api/config/coin 并写入 coinCost
 */
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      coinCost: null
    }
  },
  mounted () {
    if (this.active) this.loadCoinCost()
  },
  watch: {
    active (val) {
      if (val) this.loadCoinCost()
    }
  },
  methods: {
    loadCoinCost () {
      var key = this.$options.coinCostKey
      if (!key) return
      var self = this
      getCoinConfig().then(function (data) {
        if (!data || typeof data !== 'object') {
          self.coinCost = null
          return
        }
        var v = data[key]
        if (v != null && String(v).trim() !== '') {
          var n = Number(v)
          self.coinCost = Number.isFinite(n) ? n : null
        } else {
          self.coinCost = null
        }
      }).catch(function () {
        self.coinCost = null
      })
    }
  }
}
